import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Divider } from '@mui/material';
import { Typography } from '@mui/material';
import React from 'react';
import usePopup from 'src/logic/hooks/use-popup';
import { StyledPopper } from 'src/ui/components/shared';

type IProps<T = any> = {
  title: string;
  items: T[];
  renderItem: (item: T) => React.ReactNode;
};

const InfoPopperList = <T,>({ title, items, renderItem }: IProps<T>) => {
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  const popper = usePopup();

  return (
    <>
      <button type='button' style={{ all: 'unset', cursor: 'pointer' }} ref={anchorRef} onClick={popper.handleOpen}>
        <InfoOutlinedIcon sx={{ color: '#89B1C6', fontSize: 17, transform: 'translateY(3px)' }} />
      </button>

      <StyledPopper open={popper.isOpen} anchorEl={anchorRef.current} handleClose={popper.handleClose} zIndex={1200}>
        <div style={{ padding: '1rem', width: '300px' }}>
          <Typography fontSize={14} fontWeight={600} color='#3A3E50' pb={1}>
            {title}
          </Typography>
          <Divider />
          <div style={{ maxHeight: '200px', marginTop: '10px', overflow: 'auto', paddingInlineEnd: '.5rem' }} className='styled-scrollbar'>
            {items.map(renderItem)}
          </div>
        </div>
      </StyledPopper>
    </>
  );
};

export default InfoPopperList;
